<ng-container *ngIf="isMobile">
	<app-mobile-timeline-template-v2
		previous=""
		(goBack)="closeModal()"
		[version]="customTimelineVersion.version_4">
	</app-mobile-timeline-template-v2>
</ng-container>

<div class="flex flex-col gap-[8px] p-[16px]">
	<img class="warning-image" alt="" src="assets/images/svgs/warning-icon.svg" />
	<h1 class="text-[28px] text-[#8B2C3C] font-semibold text-center">Issues Found</h1>
	<div class="text-center text-[16px]">
		{{description}}
	</div>
	<div class="issue-card flex gap-[12px]">
		<ng-mf-avatar avatarStyle="ghost" [avatarType]="initials"></ng-mf-avatar>
		<div class="flex-1 flex flex-col">
			<div class="text-[14px] text-[#000000] font-semibold">{{fullName}}</div>
			<div class="flex gap-[12px]">
				<div class="py-[2px] px-[4px] bg-[#E6EEFD] rounded-[4px] text-[10px] text-[#0361F0] font-bold">
					NIN: {{nin}}
				</div>
				<div class="py-[2px] px-[4px] bg-[#E6EEFD] rounded-[4px] text-[10px] text-[#0361F0] font-bold">
					BVN: {{bvn}}
				</div>
			</div>
		</div>
	</div>
	<ng-container *ngFor="let item of transformedData">
		<div class="text-[12px] text-[#808080] font-semibold pt-[8px]">
			{{item.label}}
		</div>
		<div class="issue-card flex flex-col gap-[12px]">
			<div class="flex gap-[8px]">
				<div class="flex-1 flex flex-col bg-[#F2F7FE] p-[8px] gap-[8px] rounded-[12px]">
					<ng-container *ngFor="let field of item.ninFields">
						<ng-container *ngTemplateOutlet="fieldTemplate; context: { field }"></ng-container>
					</ng-container>
				</div>
				<div class="flex-1 flex flex-col bg-[#F2F7FE] p-[8px] gap-[8px] rounded-[12px]">
					<ng-container *ngFor="let field of item.bvnFields">
						<ng-container *ngTemplateOutlet="fieldTemplate; context: { field }"></ng-container>
					</ng-container>
				</div>
			</div>
			<ng-container *ngFor="let issue of item.issues">
				<div class="flex gap-[8px]">
					<app-icon icon="information"></app-icon>
					<div class="flex-1 flex flex-col">
						<div class="text-[14px] text-[#000000] font-semibold">{{issue.issueType}}</div>
						<p class="text-[10px] font-medium">
							{{issue.message}}
						</p>
					</div>
				</div>
			</ng-container>
		</div>
	</ng-container>
	<div class="kamona-desktop-button-wrapper-v2 grow flex justify-end pt-[16px]">
		<app-kamona-custom-button
			[class.grow]="isMobile"
			[isBlock]="isMobile"
			(submitForm)="closeModal()"
			[type]="'primary'"
			[text]="getButtonText()">
		</app-kamona-custom-button>
	</div>
</div>

<ng-template #fieldTemplate let-field="field">
	<div class="flex flex-col">
		<div class="text-[12px] text-[#808080] font-medium">{{field.label}}</div>
		<ng-container *ngIf="field.value; else missingField">
			<div class="value-field text-[12px] text-[#000000] font-medium flex gap-[2px] items-center">
				<div>{{field.value}}</div>
				<ng-container *ngIf="field.compareValue && field.value !== field.compareValue">
					<app-icon icon="red-warning"></app-icon>
				</ng-container>
			</div>
		</ng-container>
		<ng-template #missingField>
			<div class="bg-[#FDECEC] py-[2px] px-[4px] rounded-[4px] text-[10px] text-[#E94444] font-bold self-start">
				Missing
			</div>
		</ng-template>
	</div>
</ng-template>
